import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_doc_approval_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  claim_submitted_date: fromDatatype.TimestampTzDatatypeInterface;
  action_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  ip_address: fromDatatype.VarcharDatatypeInterface;
  esignature: fromDatatype.VarcharDatatypeInterface;
  cookies: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approver_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  approver_name: fromDatatype.VarcharDatatypeInterface;
  approver_action: fromDatatype.VarcharDatatypeInterface;
  approval_level: fromDatatype.IntegerDatatypeInterface;
  is_delegated_approval: boolean;
  delegating_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delegating_approver_name: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_aat_claim_doc_approval_history_RowClass implements bl_aat_claim_doc_approval_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  claim_submitted_date: fromDatatype.TimestampTzDatatypeInterface;
  action_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  ip_address: fromDatatype.VarcharDatatypeInterface;
  esignature: fromDatatype.VarcharDatatypeInterface;
  cookies: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approver_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  approver_name: fromDatatype.VarcharDatatypeInterface;
  approver_action: fromDatatype.VarcharDatatypeInterface;
  approval_level: fromDatatype.IntegerDatatypeInterface;
  is_delegated_approval: boolean;
  delegating_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delegating_approver_name: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_guid: fromDatatype.GuidDataFieldInterface;
}
